// RITA-1525 — Hook: Vertragsarten mit Logo für den Vertragseditor (Dokument: api/vertragsartenMitLogo.ts).
//
// `cache-and-network`: ein in den Einstellungen geändertes Logo erscheint beim nächsten Öffnen des
// Editors ohne Neuladen der App; ein offener Editor holt es nicht von selbst nach. Hat der Cache
// schon einen Stand (erneutes Öffnen oder vorheriger Besuch von Einstellungen → Vertragsarten, die
// dasselbe Feld abfragen), liefert Apollo zuerst diesen Stand und fragt zugleich neu ab.
//
// `laedt` und `fehler` beschreiben immer den AKTUELLEN Abruf, auch wenn schon Daten im Cache liegen
// (Codex-Prüfung zu MR !754 vom 29.09.2026, AK5): Sonst bliebe nach einem gescheiterten Abruf das
// alte Logo ohne Fehlermeldung auswählbar. `vertragsarten` behält dabei den zuletzt geladenen Stand,
// damit die gewählte Vertragsart in der Auswahl und ihr Logo auf den Seiten stehen bleiben
// (Entscheidung Julia 29.09.2026; greift mit gespeicherten Vorlagen ab Teilpaket 4). Dass sie beim
// Laden oder bei einem Fehler nicht als gelöscht gilt, regelt die Werkzeugleiste über `laedt`/`fehler`.
// Die Liste ist nach Titel sortiert, damit sie unabhängig von der Datenbankreihenfolge stabil bleibt.
import { VertragsartenStand } from '../api/vertragsartenMitLogo';
import useVertragsartenNeuladbar from './useVertragsartenNeuladbar';

export default function useVertragsartenMitLogo(): VertragsartenStand {
  return useVertragsartenNeuladbar().stand;
}
